module.exports = __webpack_public_path__ + "img/DSC_2654-xs.daf0fad5.png";